import React from 'react';
import { Colors } from '@/common/colors/colors';
import {
	CollapsibleHeader,
	DetailSection,
	TranscriptionBox,
	TranscriptionLang,
} from '../../callAnalysis.styles';

const AnalysisTranscript = ({
	storedDocumentId,
	showTranscript,
	transcripts,
	transcriptError,
	transcriptLoading,
	onToggle,
}) => {
	if (!storedDocumentId) {
		return null;
	}

	return (
		<DetailSection>
			<CollapsibleHeader type='button' onClick={onToggle}>
				<span>{showTranscript ? '▼' : '▶'}</span>
				<span>Transcript</span>
			</CollapsibleHeader>
			{showTranscript && (
				<>
					{transcriptLoading && (
						<p style={{ color: Colors.darkBlue, margin: '10px 0 0' }}>
							Loading transcript…
						</p>
					)}
					{transcriptError && (
						<p style={{ color: Colors.red, margin: '10px 0 0' }}>
							{transcriptError}
						</p>
					)}
					{!transcriptLoading &&
						!transcriptError &&
						transcripts?.map((item) => (
							<TranscriptionBox key={item.lang || item.text}>
								{item.lang && (
									<TranscriptionLang>{item.lang}</TranscriptionLang>
								)}
								{item.text || '—'}
							</TranscriptionBox>
						))}
					{!transcriptLoading &&
						!transcriptError &&
						transcripts?.length === 0 && (
							<p style={{ color: Colors.darkBlue, margin: '10px 0 0' }}>
								No transcript text.
							</p>
						)}
				</>
			)}
		</DetailSection>
	);
};

export default AnalysisTranscript;
